<template>
  <div class="page-wrap">
    <el-card shadow="never">
      <div class="header">
        <span>{{ isDelete ? '重新开户' : isRestart ? '重新审核' : isEdit ? '编辑开户' : '新增开户' }}</span>
        <div class="actions">
          <el-button @click="$router.back()">返回</el-button>
          <el-button type="success" @click="onSave" v-if="!isEdit && !isDelete" v-loading="zcBtnLoading">暂存</el-button>
          <el-button type="primary" @click="onSubmit" v-loading="btnLoading">保存</el-button>
        </div>
      </div>

      <el-form ref="form" :model="form" :rules="rules" label-width="140px" label-position="left">
        <!-- 基础信息（示例，保留你的其余项） -->
        <el-divider content-position="left">基础信息</el-divider>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="会员类型" prop="merchantType">
              <el-radio-group v-model.trim="form.merchantType" :disabled="isEdit">
                <el-radio v-for="(sf, index) in merchantTypeOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请类型" prop="merchantProperties">
              <el-radio-group v-model.trim="form.merchantProperties" :disabled="isEdit">
                <el-radio v-for="(sf, index) in merchantPropertiesOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户门店" prop="storeId">
              <el-select v-model.trim="form.storeId" filterable placeholder="请选择" v-if="!isEdit && !isDelete">
                <el-option v-for="opt in storeList" :key="opt.id" :label="opt.storename" :value="opt.id"/>
              </el-select>
              <span v-else>{{form.storeName}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 企业商户基础参数（省略部分字段，与你现有一致即可） -->
        <el-divider content-position="left">企业商户基础参数</el-divider>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="客户名称" prop="createBaseInfo.customerName">
              <el-input v-model.trim="form.createBaseInfo.customerName"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="营业执照号" prop="createBaseInfo.licenseNum">
              <el-input v-model.trim="form.createBaseInfo.licenseNum"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="执照所在地" prop="createBaseInfo.licenseAddress">
              <el-input v-model.trim="form.createBaseInfo.licenseAddress"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="营业开始时间" prop="createBaseInfo.operationStartTerm">
              <el-date-picker v-model.trim="form.createBaseInfo.operationStartTerm" type="date" value-format="yyyy-MM-dd"
                              placeholder="选择日期"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="营业期限" prop="createBaseInfo.operationEndTerm">
              <div style="display: flex">
                <div style="width: 20%">
                  <el-radio-group v-model.trim="form.createBaseInfo.operationEndTermType" @change="handleTermTypeChange">
                    <el-radio v-for="(sf, index) in xqOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
                  </el-radio-group>
                </div>
                <div style="flex: 1">
                  <el-date-picker v-model.trim="form.createBaseInfo.operationEndTerm" type="date" value-format="yyyy-MM-dd"
                                  placeholder="选择日期" :readonly="form.createBaseInfo.operationEndTermType == '1'"/>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人代表" prop="createBaseInfo.legalName">
              <el-input v-model.trim="form.createBaseInfo.legalName"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="法人证件种类" prop="createBaseInfo.corporationCertificatesType">
              <el-select v-model.trim="form.createBaseInfo.corporationCertificatesType" filterable placeholder="请选择">
                <el-option v-for="opt in certificatesTypeOptions" :key="opt.value" :label="opt.label"
                           :value="opt.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人身份证号" prop="createBaseInfo.idCard">
              <el-input v-model.trim="form.createBaseInfo.idCard"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人联系手机" prop="createBaseInfo.linkMobile">
              <el-input v-model.trim="form.createBaseInfo.linkMobile"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="证件开始时间" prop="createBaseInfo.legalStartDate">
              <el-date-picker v-model.trim="form.createBaseInfo.legalStartDate" type="date" value-format="yyyy-MM-dd"
                              placeholder="选择日期"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件结束时间" prop="createBaseInfo.legalEndDate">
              <div style="display: flex">
                <div style="width: 20%">
                  <el-radio-group v-model.trim="form.createBaseInfo.legalEndDateType" @change="handleLegalTypeChange">
                    <el-radio v-for="(sf, index) in xqOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
                  </el-radio-group>
                </div>
                <div style="flex: 1">
                  <el-date-picker v-model.trim="form.createBaseInfo.legalEndDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="选择日期" :readonly="form.createBaseInfo.legalEndDateType == '1'"/>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人归属地" prop="createBaseInfo.legalAddress">
              <el-input v-model.trim="form.createBaseInfo.legalAddress"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="办公地址" prop="createBaseInfo.workingAddress">
              <el-input v-model.trim="form.createBaseInfo.workingAddress"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="企业联系电话">
              <el-input v-model.trim="form.createBaseInfo.telephone"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实际经营地址">
              <el-input v-model.trim="form.createBaseInfo.actualOperatingAddress"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="注册地址" prop="createBaseInfo.registeredAddress">
              <el-input v-model.trim="form.createBaseInfo.registeredAddress" type="textarea" :rows="3" maxlength="100" show-word-limit/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系地址" prop="createBaseInfo.address">
              <el-input v-model.trim="form.createBaseInfo.address" type="textarea" :rows="3" maxlength="100" show-word-limit/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="法人为受益人" prop="createBaseInfo.legalIsBeneficiary">
              <el-radio-group v-model.trim="form.createBaseInfo.legalIsBeneficiary" @change="handleSyrChange">
                <el-radio v-for="(sf, index) in sfOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人为股东" prop="createBaseInfo.legalIsShareholder" @change="handleSyrChange">
              <el-radio-group v-model.trim="form.createBaseInfo.legalIsShareholder">
                <el-radio v-for="(sf, index) in sfOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人为联系人" prop="createBaseInfo.legalIsLink">
              <el-radio-group v-model.trim="form.createBaseInfo.legalIsLink" @change="onLegalIsLinkChange">
                <el-radio v-for="(sf, index) in sfOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 股东/受益人：当法人同股东/受益人（任一为1）时，可以不填，否则必填 -->
        <el-divider content-position="left">股东/受益人</el-divider>
        <el-alert type="info" :closable="false" title="如选择“法人同股东和受益人”，可不填写本节；否则至少填写一条，且字段必填"/>
        <div v-for="(item,idx) in form.shareholdersInfos" :key="idx" class="dynamic-item">
          <el-row :gutter="12">
            <el-col :span="6">
              <el-form-item :prop="`shareholdersInfos.${idx}.type`" :rules="shareholderReqSelRules()">
                <el-select v-model.trim="item.type" placeholder="类型">
                  <el-option v-for="opt in shareholderTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :prop="`shareholdersInfos.${idx}.name`" :rules="shareholderReqRules()"><el-input v-model.trim="item.name" placeholder="姓名"/></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :prop="`shareholdersInfos.${idx}.certificatesType`" :rules="shareholderReqSelRules()">
                <el-select v-model.trim="item.certificatesType" placeholder="证件种类" filterable>
                  <el-option v-for="opt in certificatesTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="dyn-actions" v-if="(form.createBaseInfo.legalIsBeneficiary === '1' && form.createBaseInfo.legalIsShareholder) || idx > 0">
              <el-button icon="el-icon-delete" type="text" @click="removeShareholder(idx)">移除</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="6">
              <el-form-item :prop="`shareholdersInfos.${idx}.beneficiaryMobile`" :rules="shareholderReqRules()">
                <el-input v-model.trim="item.beneficiaryMobile" placeholder="手机号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :prop="`shareholdersInfos.${idx}.certificatesNumber`" :rules="shareholderReqRules()">
                <el-input v-model.trim="item.certificatesNumber" placeholder="证件号码"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :prop="`shareholdersInfos.${idx}.certificatesStartDate`" :rules="rules.req">
                <el-date-picker v-model.trim="item.certificatesStartDate" type="date" value-format="yyyy-MM-dd"
                                placeholder="开始日期"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :prop="`shareholdersInfos.${idx}.certificatesExpiryDate`" :rules="rules.req">
                <div style="display: flex">
                  <div style="width: 20%">
                    <el-radio-group v-model.trim="item.certificatesExpiryDateType" @change="handleCertificatesTypeChange(idx)">
                      <el-radio v-for="(sf, index) in xqOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
                    </el-radio-group>
                  </div>
                  <div style="flex: 1">
                    <el-date-picker v-model.trim="item.certificatesExpiryDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="到期日期" :readonly="item.certificatesExpiryDateType == '1'"/>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :prop="`shareholdersInfos.${idx}.address`" :rules="rules.req">
                <el-input v-model.trim="item.address" placeholder="联系地址"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </div>
        <el-button icon="el-icon-plus" @click="addShareholder">添加股东/受益人</el-button>

        <!-- 经营场景：contextType=1(线下) 其它字段可不填；否则必填 -->
        <el-divider content-position="left">客户经营场景</el-divider>
        <div v-for="(item,idx) in form.cdpMerchantContextInfos" :key="'ctx-'+idx" class="dynamic-item">
          <el-row :gutter="12">
            <el-col :span="6">
              <el-form-item :prop="`cdpMerchantContextInfos.${idx}.contextType`" :rules="rules.req">
                <el-select v-model.trim="item.contextType" placeholder="经营类型" @change="onContextTypeChange(item, idx)">
                  <el-option v-for="opt in contextTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :prop="`cdpMerchantContextInfos.${idx}.contextName`" :rules="contextOtherRules(item)">
                <el-input v-model.trim="item.contextName" placeholder="应用名称"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :prop="`cdpMerchantContextInfos.${idx}.contextAdd`" :rules="contextOtherRules(item)">
                <el-input v-model.trim="item.contextAdd" placeholder="链接地址"/>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :prop="`cdpMerchantContextInfos.${idx}.contextBelongNo`">
                <el-input v-model.trim="item.contextBelongNo" placeholder="备案号"/>
              </el-form-item>
            </el-col>
            <el-col :span="2" class="dyn-actions">
              <el-button type="text" icon="el-icon-delete" @click="form.cdpMerchantContextInfos.splice(idx,1)" v-if="idx > 0">移除
              </el-button>
            </el-col>
          </el-row>
          <el-alert type="info" :closable="false" v-if="item.contextType==='1'" title="选择线下时可不填其余字段"/>
          <el-divider></el-divider>
        </div>
        <el-button icon="el-icon-plus" @click="form.cdpMerchantContextInfos.push({contextType:'',contextName:'',contextAdd:'',contextBelongNo:''})">添加经营场景</el-button>

        <!-- 客户文件列表（文件uuid） -->
        <el-divider content-position="left">客户文件</el-divider>
        <div v-for="(item,idx) in form.merchantFileInfos" :key="'file'+idx" class="dynamic-item">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :prop="`merchantFileInfos.${idx}.fileType`" :rules="rules.reqSel">
                <el-select v-model.trim="item.fileType" placeholder="请选择" filterable style="width:240px" @change="handleFileChange(idx)">
                  <el-option v-for="opt in fileTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :prop="`merchantFileInfos.${idx}.fileUuid`" :rules="rules.reqSel">
                <el-upload
                    v-if="item.fileType && item.fileType !== '9999999'"
                    :show-file-list="false"
                    :on-success="(res, file) => uploadSuccess(res, file, idx)"
                    :on-error="(err, file) => uploadError(err, file, idx)"
                    list-type="picture-card"
                    accept="image/jpeg,image/png"
                    name="multipartFile"
                    :data="{fileType: item.fileType, index: idx}"
                    :action="uploadurl"
                    :ref="`upload-${idx}`">
                    <div class="avatar-wrapper" @click="handleClickUpload(idx)">
                      <img v-if="item.filePath" :src="prefixUrl + item.filePath" class="avatar">
                      <div v-if="item.filePath" class="mask">
                        <span class="el-icon-refresh">点击替换</span>
<!--                        <span class="el-icon-delete">点击删除</span>-->
                      </div>
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                </el-upload>
                <el-upload
                    v-else-if="item.fileType"
                    class="upload-demo"
                    :action="uploadurl"
                    accept="application/x-zip-compressed"
                    :on-success="(res, file) => uploadSuccess(res, file, idx)"
                    :on-error="(err, file) => uploadError(err, file, idx)"
                    :on-exceed="(file, fileList) => handleProgress(file, fileList, idx)"
                    :on-remove="(file, fileList) => handleRemove(file, fileList, idx)"
                    :data="{fileType: item.fileType, index: idx}"
                    name="multipartFile"
                    drag
                    :limit="1"
                    :file-list="item.fileList"
                    :ref="`upload-${idx}`">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div slot="tip" class="el-upload__tip">只能上传zip文件，且不超过2M</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="dyn-actions">
              <el-button icon="el-icon-delete" type="text" @click="handleDelFile(idx, item.fileUuid)" v-if="idx > 0 && (!isEdit || item.isAdd)">移除</el-button>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </div>
        <el-button icon="el-icon-plus" style="margin-top:10px"
                   @click="form.merchantFileInfos.push({fileType:'',fileUuid:'', filePath: '', fileList: [], isAdd: true})" v-if="!isEdit">添加文件
        </el-button>

        <!-- 银行信息 -->
        <el-divider content-position="left">客户银行信息</el-divider>
        <el-row :gutter="12">
          <el-col :span="6">
            <el-form-item label="银行卡类型" prop="cdpMerchantBankInfo.bankType">
<!--              <el-select v-model.trim="form.cdpMerchantBankInfo.bankType" @change="handleBanckInfo">-->
              <el-select v-model.trim="form.cdpMerchantBankInfo.bankType">
                <el-option v-for="opt in bankTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开户名" prop="cdpMerchantBankInfo.accountName">
              <el-input v-model.trim="form.cdpMerchantBankInfo.accountName"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开户行名称" prop="cdpMerchantBankInfo.bankName">
              <el-input v-model.trim="form.cdpMerchantBankInfo.bankName"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="银行卡号" prop="cdpMerchantBankInfo.bankAccount">
              <el-input v-model.trim="form.cdpMerchantBankInfo.bankAccount"/>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <el-row :gutter="12" v-if="form.cdpMerchantBankInfo.bankType==='2'">-->
        <el-row :gutter="12">
          <el-col :span="6">
            <el-form-item label="开户省" prop="cdpMerchantBankInfo.bankProvince">
              <el-input v-model.trim="form.cdpMerchantBankInfo.bankProvince"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开户市" prop="cdpMerchantBankInfo.bankCity">
              <el-input v-model.trim="form.cdpMerchantBankInfo.bankCity"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行地址" prop="cdpMerchantBankInfo.bankAddress">
              <el-input v-model.trim="form.cdpMerchantBankInfo.bankAddress"/>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 联系人信息：当 legalIsLink=1 时可不填，否则必填 -->
        <el-divider content-position="left">客户联系人信息</el-divider>
        <el-row :gutter="12">
          <el-col :span="6">
            <el-form-item label="业务联系人" prop="cdpMerchantLinkInfo.businessName" :rules="linkReqRules()">
              <el-input v-model.trim="form.cdpMerchantLinkInfo.businessName"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="证件种类" prop="cdpMerchantLinkInfo.certificatesType" :rules="linkReqSelRules()">
              <el-select v-model.trim="form.cdpMerchantLinkInfo.certificatesType" filterable>
                <el-option v-for="opt in certificatesTypeOptions" :key="opt.value" :label="opt.label"
                           :value="opt.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="证件号码" prop="cdpMerchantLinkInfo.certificatesNumber" :rules="linkReqRules()">
              <el-input v-model.trim="form.cdpMerchantLinkInfo.certificatesNumber"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务联系人手机" prop="cdpMerchantLinkInfo.businessPhone" :rules="rules.req">
              <el-input v-model.trim="form.cdpMerchantLinkInfo.businessPhone"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="6">
            <el-form-item label="业务邮箱" prop="cdpMerchantLinkInfo.businessEmail" :rules="rules.req">
              <el-input v-model.trim="form.cdpMerchantLinkInfo.businessEmail"/>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="证件开始时间" prop="cdpMerchantLinkInfo.certificatesStartDate" :rules="linkReqSelRules()">
              <el-date-picker v-model.trim="form.cdpMerchantLinkInfo.certificatesStartDate" type="date"
                              value-format="yyyy-MM-dd"/>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="证件结束时间" prop="cdpMerchantLinkInfo.certificatesExpiryDate" :rules="linkReqSelRules()">
              <div style="display: flex">
                <div style="width: 20%">
                  <el-radio-group v-model.trim="form.cdpMerchantLinkInfo.certificatesExpiryDateType" @change="handleExpiryTypeChange">
                    <el-radio v-for="(sf, index) in xqOptions" :key="index" :label="sf.value">{{ sf.label }}</el-radio>
                  </el-radio-group>
                </div>
                <div style="flex: 1">
                  <el-date-picker v-model.trim="form.cdpMerchantLinkInfo.certificatesExpiryDate" type="date" value-format="yyyy-MM-dd"
                                  placeholder="到期日期" :readonly="form.cdpMerchantLinkInfo.certificatesExpiryDateType == '1'"/>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 经营信息 -->
        <el-divider content-position="left">客户经营信息</el-divider>
        <el-row :gutter="12">
          <el-col :span="6">
            <el-form-item label="经营模式" prop="cdpMerchantBusinessInfo.businessType">
              <el-select v-model.trim="form.cdpMerchantBusinessInfo.businessType">
                <el-option v-for="opt in businessTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="经营描述" prop="cdpMerchantBusinessInfo.businessDesc">
              <el-input v-model.trim="form.cdpMerchantBusinessInfo.businessDesc" type="textarea" :rows="2"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="经营大类" prop="cdpMerchantBusinessInfo.businessPrimaryTypeId">
              <el-select v-model.trim="form.cdpMerchantBusinessInfo.businessPrimaryTypeId" filterable placeholder="请选择">
                <el-option v-for="opt in businessPrimaryOptions" :key="opt.value" :label="opt.label"
                           :value="opt.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="经营细类" prop="cdpMerchantBusinessInfo.businessSecondaryTypeId">
              <el-select v-model.trim="form.cdpMerchantBusinessInfo.businessSecondaryTypeId" filterable placeholder="请选择">
                <el-option v-for="opt in businessSecondaryOptions" :key="opt.value" :label="opt.label"
                           :value="opt.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="行业大类" prop="cdpMerchantBusinessInfo.industryTypeId">
              <el-select v-model.trim="form.cdpMerchantBusinessInfo.industryTypeId" filterable placeholder="请选择">
                <el-option v-for="opt in industryPrimaryOptions" :key="opt.value" :label="opt.label"
                           :value="opt.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="行业细类" prop="cdpMerchantBusinessInfo.industrySecondaryTypeId">
              <el-select v-model.trim="form.cdpMerchantBusinessInfo.industrySecondaryTypeId" filterable placeholder="请选择">
                <el-option v-for="opt in industrySecondaryOptions" :key="opt.value" :label="opt.label"
                           :value="opt.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 其他说明 -->
        <el-divider content-position="left" v-if="!isEdit">其他说明</el-divider>
        <el-form-item label="备注" v-if="!isEdit">
          <el-input v-model.trim="form.cdpMerchantOtherNoteInfo.note" type="textarea" :rows="2"/>
        </el-form-item>

        <!-- 协议签署申请 + 计费规则（含两类子策略的可视化编辑） -->
        <el-divider content-position="left" v-if="isRestart || !isEdit">协议签署申请</el-divider>
        <el-row :gutter="12" v-if="isRestart || !isEdit">
          <el-col :span="6">
            <el-form-item label="签署方式" prop="apiAgreementSignApplyInfo.signedWay">
              <el-select v-model.trim="form.apiAgreementSignApplyInfo.signedWay">
                <el-option v-for="opt in signedWayOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-table :data="form.apiAgreementSignApplyInfo.feeRuleList" size="small" border v-if="isRestart || !isEdit">
          <el-table-column label="产品" width="180">
            <template slot-scope="{row}">
              <el-select v-model.trim="row.productId" :disabled="true">
                <el-option v-for="opt in productOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="开始生效" width="160">
            <template slot-scope="{row}">
             <el-date-picker v-model.trim="row.beginEffectiveTime" type="date" value-format="yyyy-MM-dd"/>
            </template>
          </el-table-column>
<!--          <el-table-column label="计费模式" width="160">-->
<!--            <template slot-scope="{row}">-->
<!--              <el-select v-model.trim="row.billModel" style="width:140px" @change="changeBillModel(row)" :disabled="isEdit">-->
<!--                <el-option label="费率模式" value="1"/>-->
<!--                <el-option label="固定值模式" value="2"/>-->
<!--              </el-select>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="策略" min-width="480">
            <template slot-scope="{row}">
              <!-- 费率模式：rateRuleStrategyList -->
              <div v-if="row.billModel==='1'">
                <el-table size="mini" :data="row.rateRuleStrategyList" border>
                  <el-table-column label="费率(五位小数)" width="180">
                    <template slot-scope="{row:rr}"><el-input v-model.trim="rr.feeRate" placeholder="如 0.00350"/></template>
                  </el-table-column>
                  <el-table-column label="最低收费(元)" width="160">
                    <template slot-scope="{row:rr}"><el-input v-model.trim="rr.minFee" readonly/></template>
                  </el-table-column>
                  <el-table-column label="最高收费(元)" width="160">
                    <template slot-scope="{row:rr}"><el-input v-model.trim="rr.maxFee"/></template>
                  </el-table-column>
                  <el-table-column label="操作" width="100" v-if="!isEdit">
                    <template slot-scope="{ $index }"><el-button type="text" icon="el-icon-delete" @click="row.rateRuleStrategyList.splice($index,1)">移除</el-button></template>
                  </el-table-column>
                </el-table>
                <el-button size="mini" icon="el-icon-plus" @click="addRateRule(row)" style="margin-top:6px">添加费率策略</el-button>
              </div>

              <!-- 固定值模式：amountAgreementFeeStrategyList -->
              <div v-else-if="row.billModel==='2'">
                <el-table size="mini" :data="row.amountAgreementFeeStrategyList" border>
                  <el-table-column label="固定值(元)" width="220">
                    <template slot-scope="{row:ar}"><el-input v-model.trim="ar.baseRee" placeholder="支持两位小数"/></template>
                  </el-table-column>
                  <el-table-column label="操作" width="100" v-if="!isEdit">
                    <template slot-scope="{ $index }">
                      <el-button type="text" icon="el-icon-delete" @click="row.amountAgreementFeeStrategyList.splice($index,1)">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button size="mini" icon="el-icon-plus" @click="addAmountRule(row)" style="margin-top:6px">添加固定值策略</el-button>
              </div>
              <div v-else class="text-muted">请选择计费模式</div>
            </template>
          </el-table-column>
<!--          <el-table-column label="操作" width="100" v-if="!isEdit">-->
<!--            <template slot-scope="{ $index }"><el-button type="text" icon="el-icon-delete" v-if="form.apiAgreementSignApplyInfo.feeRuleList.length > 1"-->
<!--                                                         @click="form.apiAgreementSignApplyInfo.feeRuleList.splice($index,1)">移除</el-button></template>-->
<!--          </el-table-column>-->
        </el-table>


<!--        <el-button icon="el-icon-plus" style="margin-top:10px" @click="addFeeRule" v-if="!isEdit">添加计费规则</el-button>-->
      </el-form>
    </el-card>

    <!--暂存记录对话框-->
    <el-dialog title="暂存记录" :visible.sync="buyDialogVisible" width="500" >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form>
            <el-form-item label="开户门店" prop="storeId">
              <el-select v-model.trim="storeId" filterable clearable placeholder="请选择" @change="getZc('selected')">
                <el-option v-for="opt in zcStores" :key="opt.storeId" :label="opt.storename" :value="opt.storeId"/>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-card>
        <el-table :data="zclist"  style="width: 100%" stripe size="small" height="500">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="门店" prop="storename"></el-table-column>
          <el-table-column label="操作" width="100">
            <!--作用域插槽-->
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="使用" placement="top">
                <el-button type="warning" icon="el-icon-tickets" size="mini" @click="handleZc(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BfAccountOperator',
  data() {
    return {
      btnLoading: false,
      zcBtnLoading: false,
      buyDialogVisible: false,
      zclist: [],
      prefixUrl: this.GLOBAL.imgURL,
      uploadurl: this.GLOBAL.imgURL+'open-account/uploadPic',
      isEdit: this.$route.query.mode === 'edit' && !JSON.parse(this.$route.query.isDelete),
      isRestart: JSON.parse(this.$route.query.restart),
      isDelete: JSON.parse(this.$route.query.isDelete),
      id: this.$route.query.id || null,
      form: {},
      oldForm: null,
      // 下拉复用数据
      sfOptions: [
        {label: '是', value: '1'},
        {label: '否', value: '0'}
      ],
      xqOptions: [
        {label: '短期', value: '0'},
        {label: '长期', value: '1'}
      ],
      merchantTypeOptions: [
        {label: '个体商户', value: 'INDIVIDUAL'},
        {label: '企业商户', value: 'COMPANY'}
      ],
      merchantPropertiesOptions: [
        {label: '普通商户', value: 'AGENT_MEMBER'},
        {label: '代理商', value: 'AGENT_BRANCH'}
      ],
      shareholderTypeOptions: [
        {label: '控股股东', value: '01'},
        {label: '受益人', value: '02'}
      ],
      contextTypeOptions: [
        {label: '线下', value: '1'}, {label: 'APP', value: '2'}, {label: '网页端', value: '3'},
        {label: '小程序',value: '4'}, {label: 'H5', value: '5'}, {label: '公众号', value: '6'},
        {label: '快应用', value: '7'}
      ],
      bankTypeOptions: [
        {label: '对私', value: '1'},
        {label: '对公', value: '2'}
      ],
      signedWayOptions: [
        {label: '线上签约', value: '1'},
        {label: '线下签约', value: '2'}
      ],
      certificatesTypeOptions: [
        {label: '居民身份证', value: '0'}, {label: '军人身份证件', value: '1'},
        {label: '港澳居民来往内地通行证',value: '2'}, {label: '台湾居民来往大陆通行证', value: '3'},
        {label: '外国公民护照',value: '4'}, {label: '其他个人身份有效证件', value: '5'}, {label: '单位证件', value: '6'},
        {label: '临时居民身份证',value: '7'}, {label: '武警身份证件', value: '8'},
        {label: '其他境内个人身份有效证件',value: '9'}, {label: '其他境外个人身份有效证件', value: '10'},
        {label: '外国人永久居留证',value: '11'}, {label: '港澳居民居住证', value: '12'},
        {label: '台湾居民居住证', value: '13'}, {label: '统一社会信用代码',value: '21'},
        {label: '其他境内机构代码', value: '22'}, {label: '其他境外机构代码', value: '23'}
      ],
      fileTypeOptions: [
        {label: '个体营业执照证', value: '0102211'},
        {label: '企业营业执照证', value: '0101104'},
        {label: '企业银行开户许可证', value: '0101401'},
        {label: '个体银行开户许可证', value: '0101214'},
        {label: '企业法人身份证（人像面）', value: '0102101'},
        {label: '企业法人身份证（国徽面）', value: '0102102'},
        {label: '企业联系人身份证（人像面）', value: '0314101'},
        {label: '企业联系人身份证（国徽面）', value: '0314102'},
        {label: '个体法人身份证（人像面）', value: '0102201'},
        {label: '个体法人身份证（国徽面）', value: '0102202'},
        {label: '个体联系人身份证（人像面）', value: '0314201'},
        {label: '个体联系人身份证（国徽面）', value: '0314202'},
        {label: '股东身份证（人像面）', value: '0401101'},
        {label: '股东身份证（国徽面）', value: '0401102'},
        {label: '股东其他证件', value: '0401199'},
        {label: '受益人身份证（人像面）', value: '0402201'},
        {label: '受益人身份证（国徽面）', value: '0402202'},
        {label: '受益人其他证件', value: '0402299'},
        {label: '社保缴纳证明', value: '9999901'},
        {label: '交税证明', value: '9999902'},
        {label: '其他附件', value: '9999999'},
        {label: '经营场所照片', value: '9999914'},
        {label: 'APP页面截图', value: '9999921'},
        {label: '网站授权函', value: '9999932'},
        {label: '联合运营说明函', value: '9999942'},
        {label: '小程序页面截图', value: '9999943'},
        {label: '公众号截图', value: '9999955'},
        {label: '联合运营说明函(2)', value: '9999972'},
        {label: '快应用截图', value: '9999976'}
      ],
      businessTypeOptions: [
        {label: '自营类', value: '01'}, {label: '平台类', value: '02'},
        {label: '自营+平台',value: '03'}, {label: '入驻平台商家', value: '04'}, {label: 'SAAS服务商', value: '05'}
      ],
      productOptions: [
        {label: '线下打款', value: '104'}, {label: '工作日转账', value: '210'},
        {label: '工作日晚上转账',value: '211'}, {label: '节假日到账', value: '212'}
      ],
      // === 新增：经营/行业 下拉选项（来自实体类注释） ===
      businessPrimaryOptions: [
        {label: '消费金融公司', value: '11001'},
        {label: '信托公司', value: '11002'},
        {label: '银行', value: '11003'},
        {label: '资产管理公司', value: '11004'},
        {label: '保险', value: '11005'},
        {label: '金融租赁公司', value: '11006'},
        {label: '汽车金融公司', value: '11007'},
        {label: '小额贷款公司', value: '11008'},
        {label: '融资担保公司', value: '11009'},
        {label: '融资租赁公司', value: '11010'},
        {label: '商业保理公司', value: '11011'},
        {label: '助贷机构', value: '11012'},
        {label: '零售类商家（实物B2C）', value: '21001'},
        {label: '集采类商家（实物B2B）', value: '21002'},
        {label: '服务类商家/服务类商家（B2B）', value: '21003'},
        {label: '公共民生类', value: '21004'},
        {label: '跨境服务贸易', value: '21005'},
        {label: '跨境货物贸易', value: '21006'}
      ],
      businessSecondaryOptions: [
        {label: '消费金融业务', value: '11001001'},
        {label: '信托业务', value: '11002001'},
        {label: '其他自营业务', value: '11003003'},
        {label: '银行理财业务', value: '11003002'},
        {label: '助贷业务', value: '11003004'},
        {label: '银行贷款业务', value: '11003001'},
        {label: '资产管理服务', value: '11004001'},
        {label: '保险代理/经纪公司自营业务', value: '11005002'},
        {label: '保险公司自营业务', value: '11005001'},
        {label: '信用保证保险业务', value: '11005003'},
        {label: '金融租赁业务', value: '11006001'},
        {label: '汽车金融业务', value: '11007001'},
        {label: '小额贷款业务', value: '11008001'},
        {label: '融资担保业务', value: '11009001'},
        {label: '融资租赁业务', value: '11010001'},
        {label: '商业保理业务', value: '11011001'},
        {label: '助贷业务', value: '11012001'},
        {label: '线上垂直电商', value: '21001002'},
        {label: '线上综合电商', value: '21001001'},
        {label: '公域场景电商', value: '21001003'},
        {label: '线上综合电商(B2B)', value: '21002001'},
        {label: '线上垂直电商(B2B)', value: '21002002'},
        {label: '餐旅娱乐', value: '21003002'},
        {label: '共享经济', value: '21003004'},
        {label: '交通物流', value: '21003006'},
        {label: '教育培训', value: '21003008'},
        {label: '数字娱乐', value: '21003001'},
        {label: '商业生活服务', value: '21003003'},
        {label: '车辆服务', value: '21003005'},
        {label: '网络及软硬件', value: '21003007'},
        {label: '公共管理和社会组织', value: '21004003'},
        {label: '公益慈善', value: '21004002'},
        {label: '医疗健康', value: '21004001'},
        {label: '跨境服务贸易', value: '21005001'},
        {label: '跨境货物贸易', value: '21006001'}
      ],
      industryPrimaryOptions: [
        {label: '综合电商', value: '9933001'}, {label: '社交电商', value: '9933002'},
        {label: '直销电商',value: '9933003'}, {label: '盲盒电商', value: '9933004'},
        {label: '返利电商', value: '9933005'}, {label: '海淘平台',value: '9933006'},
        {label: '便利店/超市', value: '9934001'}, {label: '自助零售', value: '9934002'},
        {label: '商场/商业街/卖场',value: '9934003'}, {label: '奥特莱斯', value: '9934004'},
        {label: '生鲜食品', value: '9935001'}, {label: '加工食品', value: '9935002'},
        {label: '综合食品',value: '9935003'}, {label: '茶叶', value: '9935004'}, {label: '酒类', value: '9935005'},
        {label: '烟草/雪茄',value: '9935006'}, {label: '营养品/保健品', value: '9935007'},
        {label: '服饰鞋包', value: '9936001'}, {label: '美妆个护', value: '9936002'},
        {label: '眼镜店',value: '9936003'}, {label: '母婴儿童', value: '9936004'},
        {label: '鲜花绿植', value: '9936005'}, {label: '宠物',value: '9936006'}, {label: '计生成人', value: '9936007'},
        {label: '贵金属/珠宝/钟表', value: '9937001'}, {label: '名牌奢侈品', value: '9937002'},
        {label: '3C数码', value: '9938001'}, {label: '家用电器', value: '9938002'},
        {label: '书报/音像', value: '9939001'}, {label: '工艺品/乐器', value: '9939002'},
        {label: '办公用品/文具',value: '9939003'}, {label: '户外运动器材', value: '9939004'},
        {label: '潮玩周边', value: '9939005'}, {label: '文物经营/复制品',value: '9939006'},
        {label: '医药销售', value: '9940001'}, {label: '医疗器械销售', value: '9940002'},
        {label: '保健辅助治疗器材',value: '9940003'},{label: '车辆零配件/用品精品', value: '9941001'},
        {label: '车辆销售', value: '9941002'}, {label: '二手车销售',value: '9941003'},
        {label: '五金商店', value: '9942001'}, {label: '建材商店', value: '9942002'},
        {label: '家具/家居家纺',value: '9942003'},{label: '工业化工', value: '9943001'},
        {label: '农业产品', value: '9943002'}, {label: '石油及石油产品',value: '9943003'},
        {label: '烟花爆竹', value: '9943004'}, {label: '工业设备售卖', value: '9943005'},
        {label: '其他专业零售店', value: '9944001'}, {label: '其他专业批发店', value: '9945001'},
        {label: '网络会员权益', value: '9946001'}, {label: '社交/论坛/博客',value: '9946002'},
        {label: '图书/视频/音乐', value: '9946003'}, {label: '数码图文', value: '9946004'},
        {label: '微短剧',value: '9946005'}, {label: '网络直播', value: '9946006'}, {label: '付费电视', value: '9946007'},
        {label: '元宇宙/虚拟产品',value: '9946008'},{label: '手游页游', value: '9947001'},
        {label: '棋牌捕鱼', value: '9947002'}, {label: '游戏资讯',value: '9947003'},
        {label: '游戏交易平台', value: '9947004'},{label: '堂食餐饮', value: '9948001'},
        {label: '点心熟食', value: '9948002'}, {label: '酒饮消费',value: '9948003'},
        {label: '宴会服务', value: '9948004'},{label: '娱乐场所', value: '9949001'},
        {label: '棋牌电玩', value: '9949002'}, {label: '健身运动',value: '9949003'},
        {label: '院线演出', value: '9949004'}, {label: '游乐园', value: '9949005'},
        {label: '文化场馆',value: '9949006'}, {label: '体育场馆', value: '9949007'},
        {label: '酒旅民宿', value: '9950001'}, {label: '景区', value: '9950002'},
        {label: '景区服务',value: '9950003'}, {label: '旅行社', value: '9950004'}, {label: '旅游直销', value: '9950005'},
        {label: '邮轮列车',value: '9950006'}, {label: '旅游平台(OTA)', value: '9950007'},
        {label: '综合生活服务平台', value: '9951001'}, {label: '外卖外送',value: '9951002'},
        {label: '二手商品交易平台', value: '9951003'}, {label: '团购服务', value: '9951004'},
        {label: '众筹平台',value: '9951005'},{label: '美容美体', value: '9952001'},
        {label: '洗浴保健', value: '9952002'}, {label: '家政维修',value: '9952003'},
        {label: '装饰装修', value: '9952004'}, {label: '房屋中介服务', value: '9952005'},
        {label: '宠物医院及服务',value: '9952006'}, {label: '婚介婚庆/摄影服务', value: '9952007'},
        {label: '卡券回收', value: '9952008'}, {label: '3C回收',value: '9952009'},
        {label: '黄金奢侈品回收', value: '9952010'}, {label: '生活物资回收', value: '9952011'},
        {label: '电商代运营', value: '9953001'}, {label: '广告/会展/图文印刷', value: '9953002'},
        {label: '法律服务',value: '9953003'}, {label: '咨询审计财务', value: '9953004'},
        {label: '征信服务', value: '9953005'}, {label: '招聘服务',value: '9953006'},
        {label: '丧葬服务', value: '9953007'}, {label: '拍卖收藏', value: '9953008'},
        {label: '劳务派遣',value: '9953009'}, {label: '灵活用工(税务代缴)', value: '9953010'},
        {label: '政府补贴', value: '9953011'}, {label: '物业管理',value: '9953012'},
        {label: '公共事业(电/气/水)', value: '9954001'}, {label: '有线电视缴费', value: '9954002'},
        {label: '供暖缴费',value: '9954003'}, {label: '其他生活缴费', value: '9954004'},
        {label: '话费充值', value: '9954005'},{label: '其他商业及生活服务', value: '9955001'},
        {label: '数码产品租赁', value: '9956001'}, {label: '机动车租赁', value: '9956002'},
        {label: '工业设备租赁',value: '9956003'}, {label: '自有房产出租', value: '9956004'},
        {label: '其他租赁', value: '9956005'},{label: '共享服务', value: '9957001'}, {label: '共享两轮车', value: '9957002'},
        {label: '无人值守服务',value: '9957003'},{label: '宠物领养', value: '9958001'},
        {label: '实物消费', value: '9958002'}, {label: '服务消费',value: '9958003'},
        {label: '车辆维修养护', value: '9959001'}, {label: '停车服务', value: '9959002'},
        {label: '道路救援',value: '9959003'}, {label: '代驾服务', value: '9959004'},
        {label: '充换电', value: '9960001'}, {label: '加油卡/加油服务', value: '9960002'},
        {label: '加油站/加气站',value: '9960003'},{label: 'ETC缴费', value: '9961001'},
        {label: 'MTC收费', value: '9961002'}, {label: '高速服务区',value: '9961003'},
        {label: '高速公路收费', value: '9961004'},{label: '出租车客运', value: '9962001'},
        {label: '网约车客运', value: '9962002'}, {label: '公共交通',value: '9962003'},
        {label: '航空企业', value: '9962004'}, {label: '机场', value: '9962005'},
        {label: '机票代理人',value: '9962006'}, {label: '航空系统商', value: '9962007'},
        {label: '铁路旅客运输', value: '9962008'}, {label: '公路客运',value: '9962009'},
        {label: '物流快递', value: '9963001'}, {label: '驿站/自提柜', value: '9963002'},
        {label: '物流平台',value: '9963003'}, {label: '同城即时配送', value: '9963004'}, {label: '仓储', value: '9963005'},
        {label: '铁路运输',value: '9963006'}, {label: '船舶海运', value: '9963007'},
        {label: '国际货运代理/报关行',value: '9963008'}, {label: '其他运输代理业', value: '9963009'},
        {label: '互联网信息检索', value: '9964001'}, {label: '网络推广/网络广告', value: '9964002'},
        {label: '信息中介',value: '9964003'}, {label: '互联网基础及增值服务提供商', value: '9964004'},
        {label: '软件开发服务', value: '9965001'}, {label: '在线工具',value: '9965002'},
        {label: '其他在线应用或综合类服务', value: '9965003'}, {label: 'AI服务', value: '9965004'},
        {label: '儿童保育服务(公立/含学前)', value: '9966001'}, {label: '儿童保育服务(民办/含学前)',value: '9966002'},
        {label: '中小学校(公立)', value: '9966003'}, {label: '中小学校(民办)',value: '9966004'},
        {label: '大学与学院(公立)', value: '9966005'}, {label: '大学与学院(民办)',value: '9966006'},
        {label: '其他学校/公立培训机构', value: '9966007'},{label: '教育管理机构', value: '9967001'},
        {label: '教育培训机构(线上)',value: '9967002'}, {label: '教育培训机构(线下)', value: '9967003'},
        {label: '教育培训机构(综合)',value: '9967004'}, {label: '少年宫及青少年发展中心', value: '9967005'},
        {label: '驾校',value: '9967006'}, {label: '其他教育/培训', value: '9967007'},
        {label: '公立医院', value: '9968001'}, {label: '社区卫生服务中心',value: '9968002'},
        {label: '专业公共卫生机构', value: '9968003'}, {label: '民营医院', value: '9968004'},
        {label: '诊所',value: '9968005'}, {label: '医疗美容', value: '9968006'},
        {label: '专科医疗服务',value: '9968007'}, {label: '医学实验室及诊断中心', value: '9968008'},
        {label: '线上医疗服务', value: '9968009'},{label: '护理机构服务', value: '9969001'},
        {label: '体检/健康咨询',value: '9969002'}, {label: '其他医疗保健服务', value: '9969003'},
        {label: '慈善和社会公益服务', value: '9970001'}, {label: '公益彩票', value: '9970002'},
        {label: '政府机构', value: '9971001'}, {label: '行政费用和罚款(非税)', value: '9971002'},
        {label: '公积金',value: '9971003'}, {label: '公安交管', value: '9971004'}, {label: '医保', value: '9971005'},
        {label: '社会保障服务',value: '9971006'}, {label: '政府采购', value: '9971007'}, {label: '文体机构', value: '9971008'},
        {label: '政府贷款',value: '9971009'}, {label: '法庭费用', value: '9971010'}, {label: '保释金', value: '9971011'},
        {label: '税务',value: '9971012'}, {label: '使领馆', value: '9971013'}, {label: '行业协会和专业社团', value: '9971014'},
        {label: '汽车协会',value: '9971015'}, {label: '宗教组织/祠堂/寺庙', value: '9971016'},
        {label: '其他会员组织',value: '9971017'}, {label: '中国共产党机关', value: '9971018'}
      ],
      // 行业细类（与上面相同编码池，作为独立选择）
      industrySecondaryOptions: [],
      rules: this.buildRules(),
      storeList: [],
      editFile: [],
      zcStores: [],
      storeId: null
    }
  },
  created() {
    // 行业细类复用同一编码池（如果你有真正的子项关系，可以改为根据大类过滤）
    this.industrySecondaryOptions = this.industryPrimaryOptions.slice()
    this.getList()
    this.getEmptyForm()
  },
  computed:{
    legalShareOrBeneficiary(){
      const c = this.form.createBaseInfo
      return c.legalIsBeneficiary === '1' || c.legalIsShareholder === '1'
    }
  },
  methods: {
    async getList(){
      const { data:res } = await this.$http.get('open-account/getStores/')
      this.storeList = res.data
      this.storeList.push({id: '-1', storename: '公司账户'})
    },
    async getEmptyForm() {
      this.reset()
      if (this.$route.query.mode === 'edit') {
        const { data:res } = await this.$http.get('open-account/' + this.id)
        let obj = res.data
        if (obj.createBaseInfo.operationEndTerm == '9999-12-31') {
          obj.createBaseInfo.operationEndTermType = '1'
        } else {
          obj.createBaseInfo.operationEndTermType = '0'
        }
        if (obj.createBaseInfo.legalEndDate == '9999-12-31') {
          obj.createBaseInfo.legalEndDateType = '1'
        } else {
          obj.createBaseInfo.legalEndDateType = '0'
        }
        if (obj.cdpMerchantLinkInfo.certificatesExpiryDate == '9999-12-31') {
          obj.cdpMerchantLinkInfo.certificatesExpiryDateType = '1'
        } else {
          obj.cdpMerchantLinkInfo.certificatesExpiryDateType = '0'
        }
        if (obj.shareholdersInfos) {
          obj.shareholdersInfos.forEach((item, index) => {
            if (item.certificatesExpiryDate == '9999-12-31') {
              item.certificatesExpiryDateType = '1'
            } else {
              item.certificatesExpiryDateType = '0'
            }
            this.$set(obj.shareholdersInfos, index, item)
          })
        }
        if (obj.merchantFileInfos) {
          obj.merchantFileInfos.forEach((item, index) => {
            if (item.fileType == '9999999') {
              let arr = item.filePath.split('/')
              item.fileList = [{name: arr[arr.length - 1], url: item.filePath}]
              this.$set(obj.merchantFileInfos, index, item)
            }
          })
        }
        this.oldForm = JSON.stringify(obj)
        this.form = obj
      } else {
        this.getZc("init")
      }
    },
    async getZc(flag) {
      const {data:res}=await this.$http.get('/open-account/getZc/' + this.storeId)
      if (res.code == 200) {
        if (res.data) {
          if (flag == 'init') {
            this.$confirm('当前有暂存信息是否使用?', '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning'
            }).then(() => {
              this.zclist = res.data
              this.zcStores =  this.zclist.map(item => {
                return {storeId: item.storeId, storename: item.storename}
              })
              this.buyDialogVisible = true
            })
          } else {
            this.zclist = res.data
          }
        }
      }
    },
    reset() {
      // this.form = {
      //   applyNo: '',
      //   merchantType: 'COMPANY',
      //   merchantProperties: 'AGENT_MEMBER',
      //   storeId: null,
      //   createBaseInfo: {
      //     customerName: '测试商户有限公司',
      //     licenseNum: '91350100MA2Y345X7H',
      //     licenseAddress: '上海市浦东新区居里路',
      //     operationStartTerm: '2020-12-09',
      //     operationEndTerm: '2040-12-09',
      //     legalName: '张宝',
      //     corporationCertificatesType: '0',
      //     idCard: '120104200011299154',
      //     linkMobile: '13112341234',
      //     legalStartDate: '2020-12-09',
      //     legalEndDate: '2040-12-09',
      //     legalAddress: '上海市浦东新区居里路',
      //     workingAddress: '上海市浦东新区罗山路1739弄85号',
      //     telephone: '13112341234',
      //     actualOperatingAddress: '上海市浦东新区居里路',
      //     registeredAddress: '',
      //     address: '上海市浦东新区居里路',
      //     legalIsBeneficiary: '0',
      //     legalIsShareholder: '0',
      //     legalIsLink: '0'
      //   },
      //   shareholdersInfos: [
      //     {
      //       type: '01',
      //       name: '张宝',
      //       certificatesType: '0',
      //       beneficiaryMobile: '13112341234',
      //       certificatesNumber: '120104200011299154',
      //       certificatesStartDate: '2020-12-09',
      //       certificatesExpiryDate: '2040-12-09',
      //       address: '浦东新区居里路99号'
      //     },
      //     {
      //       type: '02',
      //       name: '张宝',
      //       certificatesType: '0',
      //       beneficiaryMobile: '13112341234',
      //       certificatesNumber: '120104200011299154',
      //       certificatesStartDate: '2020-12-09',
      //       certificatesExpiryDate: '2040-12-09',
      //       address: '浦东新区居里路99号'
      //     }
      //   ],
      //   cdpMerchantContextInfos: [{contextType: '2', contextName: '抖音', contextAdd: '#小程序://京东购物丨点外卖领国补/EW8GEYXPHCbPAMz', contextBelongNo: ''}],
      //   merchantFileInfos: [
      //     {fileType:'0102101',fileUuid:'f5bbda868751409c9fd1515f48b0fc85', filePath: ''},
      //     {fileType:'0102102',fileUuid:'f5bbda868751409c9fd1515f48b0fc85', filePath: ''},
      //     {fileType:'0101104',fileUuid:'c2f16b188f3d4072ba068a52aa03545e', filePath: ''},
      //     {fileType:'0101401',fileUuid:'f5bbda868751409c9fd1515f48b0fc85', filePath: ''}
      //   ],
      //   cdpMerchantBankInfo: {
      //     bankType: '2',
      //     accountName: '测试商户有限公司',
      //     bankName: '工商银行',
      //     bankAccount: '3252900000121234',
      //     bankProvince: '上海市',
      //     bankCity: '上海市',
      //     bankAddress: '浦东支行'
      //   },
      //   cdpMerchantLinkInfo: {
      //     businessName: '张宝',
      //     certificatesType: '0',
      //     certificatesNumber: '9121221',
      //     certificatesExpiryDate: '9999-12-30',
      //     certificatesStartDate: '1984-01-01',
      //     businessPhone: '13112341234',
      //     businessEmail: '853788305@qq.com'
      //   },
      //   cdpMerchantBusinessInfo: {
      //     businessType: '01',
      //     businessDesc: '测试经营范围描述',
      //     businessPrimaryTypeId: '9934',
      //     businessSecondaryTypeId: '9934001',
      //     industryTypeId: '9934001',
      //     industrySecondaryTypeId: '9934001'
      //   },
      //   cdpMerchantOtherNoteInfo: {note: ''},
      //   apiAgreementSignApplyInfo: {signedWay: '1', feeRuleList: [
      //       {
      //         productModelId: 'M2503000001',
      //         productId: '104',
      //         feeAcctId: '1',
      //         beginEffectiveTime: '2025-08-12',
      //         billModel: '1',
      //         rateRuleStrategyList:[
      //           {
      //             feeRate: '0.002',
      //             minFee: '0',
      //             maxFee: '5'
      //           }
      //         ]
      //       },
      //       {
      //         productModelId: 'M2503000001',
      //         productId: '210',
      //         feeAcctId: '1',
      //         beginEffectiveTime: '2025-08-12',
      //         billModel: '2',
      //         amountAgreementFeeStrategyList:[
      //           {
      //             baseRee: '5'
      //           }
      //         ]
      //       },
      //       {
      //         productModelId: 'M2503000001',
      //         productId: '211',
      //         feeAcctId: '1',
      //         beginEffectiveTime: '2025-08-12',
      //         billModel: '2',
      //         amountAgreementFeeStrategyList:[
      //           {
      //             baseRee: '5'
      //           }
      //         ]
      //       },
      //       {
      //         productModelId: 'M2503000001',
      //         productId: '212',
      //         feeAcctId: '1',
      //         beginEffectiveTime: '2025-08-12',
      //         billModel: '2',
      //         amountAgreementFeeStrategyList:[
      //           {
      //             baseRee: '5'
      //           }
      //         ]
      //       }
      //     ]
      //   }
      // }
      this.form = {
        applyNo: '',
        merchantType: 'INDIVIDUAL',
        merchantProperties: 'AGENT_MEMBER',
        storeId: null,
        createBaseInfo: {
          customerName: '',
          licenseNum: '',
          licenseAddress: '',
          operationStartTerm: '',
          operationEndTerm: '',
          operationEndTermType: '0',
          legalName: '',
          corporationCertificatesType: '',
          idCard: '',
          linkMobile: '',
          legalStartDate: null,
          legalEndDateType: '0',
          legalEndDate: null,
          legalAddress: '',
          workingAddress: '',
          telephone: '',
          actualOperatingAddress: '',
          registeredAddress: '',
          address: '',
          legalIsBeneficiary: '1',
          legalIsShareholder: '0',
          legalIsLink: '0'
        },
        shareholdersInfos: [
          {
            type: '',
            name: '',
            certificatesType: '',
            beneficiaryMobile: '',
            certificatesNumber: '',
            certificatesStartDate: null,
            certificatesExpiryDate: null,
            certificatesExpiryDateType: '0',
            address: ''
          }
        ],
        cdpMerchantContextInfos: [{contextType: '2', contextName: '', contextAdd: '', contextBelongNo: ''}],
        merchantFileInfos: [
          {fileType:'0102211',fileUuid:'', filePath: '', fileList: []},
          {fileType:'0102201',fileUuid:'', filePath: '', fileList: []},
          {fileType:'0102202',fileUuid:'', filePath: '', fileList: []},
          {fileType:'0101214',fileUuid:'', filePath: '', fileList: []},
          {fileType:'9999999',fileUuid:'', filePath: '', fileList: []},
        ],
        cdpMerchantBankInfo: {
          bankType: '1',
          accountName: '',
          bankName: '',
          bankAccount: '',
          bankProvince: '',
          bankCity: '',
          bankAddress: ''
        },
        cdpMerchantLinkInfo: {
          businessName: null,
          certificatesType: null,
          certificatesNumber: null,
          certificatesExpiryDate: null,
          certificatesStartDate: null,
          certificatesExpiryDateType: '0',
          businessPhone: null,
          businessEmail: null
        },
        cdpMerchantBusinessInfo: {
          businessType: '04',
          businessDesc: '24 小时智能自助健身房，凭会员码或人脸识别即可进出，无需等待人工值守。场内配备基础力量器械、跑步机等有氧设备及简易功能训练区，器材由专人定期维护保养，确保使用安全。支持线上购卡、续费，设有自助储物柜、售水机等配套设施。全程无推销干扰，主打便捷自由的健身体验，适合时间碎片化、追求自主空间的上班族、学生等人群，以高性价比和灵活营业时间满足多样化健身需求。',
          businessPrimaryTypeId: '21001',
          businessSecondaryTypeId: '21001003',
          industryTypeId: '9934002',
          industrySecondaryTypeId: '9949003'
        },
        cdpMerchantOtherNoteInfo: {note: ''},
        apiAgreementSignApplyInfo: {signedWay: '1', feeRuleList: [
            {
              productModelId: 'M2503000001',
              productId: '104',
              feeAcctId: '1',
              beginEffectiveTime: '2025-09-23',
              billModel: '1',
              rateRuleStrategyList: [
                { feeRate:'0.0025', minFee:'0', maxFee:'0' }
              ],
              amountAgreementFeeStrategyList: []
            },
            {
              productModelId: 'M2503000001',
              productId: '210',
              feeAcctId: '1',
              beginEffectiveTime: '2025-09-23',
              billModel: '2',
              rateRuleStrategyList: [],
              amountAgreementFeeStrategyList: [
                { baseRee:'1' }
              ]
            },
            {
              productModelId: 'M2503000001',
              productId: '211',
              feeAcctId: '1',
              beginEffectiveTime: '2025-09-23',
              billModel: '2',
              rateRuleStrategyList: [],
              amountAgreementFeeStrategyList: [
                { baseRee:'1' }
              ]
            },
            {
              productModelId: 'M2503000001',
              productId: '212',
              feeAcctId: '1',
              beginEffectiveTime: '2025-09-23',
              billModel: '2',
              rateRuleStrategyList: [],
              amountAgreementFeeStrategyList: [
                { baseRee:'1' }
              ]
            }
          ]}
      }
    },
    buildRules() {
      const req = [{required: true, message: '必填', trigger: 'blur'}]
      const reqSel = [{required: true, message: '必选', trigger: 'change'}]
      return {
        req, // 通用
        reqSel,
        storeId: reqSel,
        'createBaseInfo.customerName': req,
        'createBaseInfo.licenseNum': req,
        'createBaseInfo.licenseAddress': req,
        'createBaseInfo.operationStartTerm': reqSel,
        'createBaseInfo.operationEndTerm': reqSel,
        'createBaseInfo.legalName': req,
        'createBaseInfo.corporationCertificatesType': reqSel,
        'createBaseInfo.idCard': req,
        'createBaseInfo.linkMobile': req,
        'createBaseInfo.legalStartDate': reqSel,
        'createBaseInfo.legalEndDate': reqSel,
        'createBaseInfo.legalAddress': req,
        'createBaseInfo.workingAddress': req,
        'cdpMerchantBusinessInfo.businessDesc': req,
        'cdpMerchantBusinessInfo.businessType': reqSel,
        'cdpMerchantBusinessInfo.businessPrimaryTypeId': reqSel,
        'cdpMerchantBusinessInfo.businessSecondaryTypeId': reqSel,
        'cdpMerchantBusinessInfo.industryTypeId': reqSel,
        'cdpMerchantBusinessInfo.industrySecondaryTypeId': reqSel,
        'apiAgreementSignApplyInfo.signedWay': reqSel,
        'cdpMerchantBankInfo.bankType': reqSel,
        'cdpMerchantBankInfo.accountName': req,
        'cdpMerchantBankInfo.bankName': req,
        'cdpMerchantBankInfo.bankAccount': req,
        'cdpMerchantBankInfo.bankProvince': reqSel,
        'cdpMerchantBankInfo.bankCity': reqSel,
        'cdpMerchantBankInfo.bankAddress': reqSel
        // 'cdpMerchantBankInfo.bankProvince': [],
        // 'cdpMerchantBankInfo.bankCity': [],
        // 'cdpMerchantBankInfo.bankAddress': []
      }
    },
    // ===== 动态规则：股东/受益人 =====
    shareholderReqRules(){
      return this.legalShareOrBeneficiary ? [] : [{ required:true, message:'必填', trigger:'blur' }]
    },
    shareholderReqSelRules(){
      return this.legalShareOrBeneficiary ? [] : [{ required:true, message:'必选', trigger:'change' }]
    },
    // 动态返回：线下("1") => 无校验；其它 => 必填
    contextOtherRules(item){
      return item && item.contextType === '1' ? [] : [{ required:true, message:'必填', trigger:'blur' }]
    },
    // 切换类型时，清空并强制重新校验另外三项
    onContextTypeChange(item, idx){
      if(item.contextType === '1'){
        item.contextName = ''
        item.contextAdd = ''
        item.contextBelongNo = ''
      }
      this.$nextTick(()=>{
        ['contextName','contextAdd','contextBelongNo'].forEach(f=>{
          const prop = `cdpMerchantContextInfos.${idx}.${f}`
          this.$refs.form && this.$refs.form.validateField(prop, ()=>{})
        })
      })
    },
    // ===== 动态规则：联系人（法人同联系人=1时非必填） =====
    linkReqRules(){
      return this.form.createBaseInfo.legalIsLink === '1' ? [] : [{ required:true, message:'必填', trigger:'blur' }]
    },
    linkReqSelRules(){
      return this.form.createBaseInfo.legalIsLink === '1' ? [] : [{ required:true, message:'必选', trigger:'change' }]
    },
    // 切换“法人同联系人”后，强制刷新校验状态
    onLegalIsLinkChange() {
      this.$nextTick(() => {
        const fields = [
          'cdpMerchantLinkInfo.businessName',
          'cdpMerchantLinkInfo.certificatesType',
          'cdpMerchantLinkInfo.certificatesNumber',
          'cdpMerchantLinkInfo.certificatesStartDate',
          'cdpMerchantLinkInfo.certificatesExpiryDate'
        ]
        fields.forEach(prop => {
          this.$refs.form && this.$refs.form.validateField(prop, () => {})
        })
      })
    },
    // ===== 计费规则 UI 逻辑 =====
    addFeeRule() {
      this.form.apiAgreementSignApplyInfo.feeRuleList.push({
        productModelId: 'M2503000001',
        productId: '',
        feeAcctId: '1',
        beginEffectiveTime: '',
        billModel: '1',
        rateRuleStrategyList: [],
        amountAgreementFeeStrategyList: []
      })
    },
    changeBillModel(row){
      // 切换模式时清空另一个列表
      if(row.billModel === '1'){
        row.amountAgreementFeeStrategyList = []
        if(!row.rateRuleStrategyList || row.rateRuleStrategyList.length === 0){ this.addRateRule(row) }
      }else if(row.billModel === '2'){
        row.rateRuleStrategyList = []
        if(!row.amountAgreementFeeStrategyList || row.amountAgreementFeeStrategyList.length === 0){ this.addAmountRule(row) }
      }else{
        row.rateRuleStrategyList = []
        row.amountAgreementFeeStrategyList = []
      }
    },
    addRateRule(row){ row.rateRuleStrategyList.push({ feeRate:'0.0025', minFee:'0', maxFee:'0' }) },
    addAmountRule(row){ row.amountAgreementFeeStrategyList.push({ baseRee:'' }) },

    // ===== 提交前的严格校验（覆盖复杂条件） =====
    validateBeforeSubmit(){
      // 字段名到标签名的映射
      const fieldLabelMap = {
        // 股东/受益人字段
        'type': '类型',
        'name': '姓名',
        'certificatesType': '证件种类',
        'beneficiaryMobile': '手机号',
        'certificatesNumber': '证件号码',
        'certificatesStartDate': '开始日期',
        'certificatesExpiryDate': '到期日期',
        'address': '联系地址',
        // 联系人信息字段
        'businessName': '业务联系人',
        'businessPhone': '业务联系人手机',
        'businessEmail': '业务邮箱',
        // 经营场景字段
        'contextName': '应用名称',
        'contextAdd': '链接地址',
        'contextBelongNo': '备案号',
        // 计费规则字段
        'productId': '产品',
        'feeAcctId': '费用账户ID',
        'beginEffectiveTime': '开始生效',
        'billModel': '计费模式',
        'feeRate': '费率',
        'minFee': '最低收费',
        'maxFee': '最高收费',
        'baseRee': '固定值'
      }

      // 1) 股东/受益人：若未选择法人同股东/受益人，至少一条且字段完整
      if(!this.legalShareOrBeneficiary){
        if(!this.form.shareholdersInfos || this.form.shareholdersInfos.length === 0){
          return '请至少填写一条股东/受益人信息'
        }
        for(const [i,s] of this.form.shareholdersInfos.entries()){
          const missField = ['type','name','certificatesType','beneficiaryMobile','certificatesNumber','certificatesStartDate','certificatesExpiryDate','address'].find(k=>!s[k])
          if(missField) return `股东/受益人 第${i+1}条：${fieldLabelMap[missField]} 为必填`
        }
      }
      // 2) 联系人：当 legalIsLink!=1 时需要完整
      if(this.form.createBaseInfo.legalIsLink !== '1'){
        const l = this.form.cdpMerchantLinkInfo
        const missField = ['businessName','certificatesType','certificatesNumber','certificatesStartDate','certificatesExpiryDate','businessPhone','businessEmail'].find(k=>!l[k])
        if(missField) return `联系人信息：${fieldLabelMap[missField] || missField} 为必填`
      }
      // 3) 经营场景：contextType 必选；若非线下则其它字段必填
      for(const [i,c] of this.form.cdpMerchantContextInfos.entries()){
        if(!c.contextType) return `经营场景 第${i+1}条：经营类型 必选`
        if(c.contextType !== '1' && c.contextType !== '2'){
          const missField = ['contextName','contextAdd','contextBelongNo'].find(k=>!c[k])
          if(missField) return `经营场景 第${i+1}条：${fieldLabelMap[missField]} 为必填`
        } else if (c.contextType === '2') {
          const missField = ['contextName','contextAdd'].find(k=>!c[k])
          if(missField) return `经营场景 第${i+1}条：${fieldLabelMap[missField]} 为必填`
        }
      }
      // 4) 协议签署申请 + 计费规则
      if(!this.form.apiAgreementSignApplyInfo.signedWay){
        return '请选择签署方式'
      }

      // 固定值：最多 2 位小数的正则（允许整数，如 "10" 或 "10.5" 或 "10.55"）
      const twoDecimalRe = /^\d+(?:\.\d{1,2})?$/;
      const fiveDecimalRe = /^\d+(?:\.\d{1,5})?$/;

      const list = this.form.apiAgreementSignApplyInfo.feeRuleList || []
      for(const [i,r] of list.entries()){
        const baseMissField = ['productId','feeAcctId','beginEffectiveTime','billModel'].find(k=>!r[k])
        if(baseMissField) return `计费规则 第${i+1}条：${fieldLabelMap[baseMissField]} 为必填`
        if(r.billModel === '1'){
          if(!r.rateRuleStrategyList || r.rateRuleStrategyList.length===0) return `计费规则 第${i+1}条：请添加至少一条费率策略`
          for(const [j,rr] of r.rateRuleStrategyList.entries()){
            const missField = ['feeRate','minFee','maxFee'].find(k=>!rr[k])
            if(missField) return `计费规则 第${i+1}条 费率策略 第${j+1}条：${fieldLabelMap[missField]} 为必填`

            // 数字校验（最多五位小数，且非负）
            const valf = String(rr.feeRate).trim();
            if(!fiveDecimalRe.test(valf)){
              return `计费规则 第${i+1}条 费率策略 第${j+1}条：${fieldLabelMap['feeRate']} 需为非负数字，最多保留5位小数`;
            }
            // 数字校验（最多两位小数，且非负）
            const val = String(rr.minFee).trim();
            if(!twoDecimalRe.test(val)){
              return `计费规则 第${i+1}条 费率策略 第${j+1}条：${fieldLabelMap['minFee']} 需为非负数字，最多保留2位小数`;
            }
            // 数字校验（最多两位小数，且非负）
            const val2 = String(rr.maxFee).trim();
            if(!twoDecimalRe.test(val2)){
              return `计费规则 第${i+1}条 费率策略 第${j+1}条：${fieldLabelMap['maxFee']} 需为非负数字，最多保留2位小数`;
            }
          }
        }else if(r.billModel === '2'){
          if(!r.amountAgreementFeeStrategyList || r.amountAgreementFeeStrategyList.length===0) return `计费规则 第${i+1}条：请添加至少一条固定值策略`
          for(const [j,ar] of r.amountAgreementFeeStrategyList.entries()){
            if(!ar.baseRee){ return `计费规则 第${i+1}条 固定值策略 第${j+1}条：${fieldLabelMap['baseRee']} 为必填` }
            else {
              // 数字校验（最多两位小数，且非负）
              const val = String(ar.baseRee).trim();
              if(!twoDecimalRe.test(val)){
                return `计费规则 第${i+1}条 固定值策略 第${j+1}条：${fieldLabelMap['baseRee']} 需为非负数字，最多保留2位小数`;
              }
            }
          }
        }
      }
      return ''
    },
    // ===== CRUD =====
    addShareholder() {
      this.form.shareholdersInfos.push({
        type: '',
        name: '',
        certificatesType: '',
        beneficiaryMobile: '',
        certificatesNumber: '',
        certificatesStartDate: '',
        certificatesExpiryDate: '',
        certificatesExpiryDateType: '0',
        address: ''
      })
    },
    removeShareholder(i) {
      console.log(this.legalShareOrBeneficiary)
      if (!this.legalShareOrBeneficiary){
        if (this.form.shareholdersInfos.length > 1){
          this.form.shareholdersInfos.splice(i, 1)
        } else {
          this.$message.error('请至少填写一条股东/受益人信息')
        }
      } else {
        this.form.shareholdersInfos.splice(i, 1)
      }
    },
    async onSubmit() {
      // 首先执行表单基础验证
      this.$refs.form.validate(async valid => {
        if (!valid){
          this.$message.error('数据校验失败请仔细检查')
          return
        }

        // 然后执行复杂业务逻辑验证（包括feeRuleList验证）
        const customValidationMsg = this.validateBeforeSubmit()
        if (customValidationMsg) {
          this.$message.error(customValidationMsg)
          return
        }

        this.btnLoading = true
        try {
          const url = this.isDelete ? '/open-account/restartCreate' : this.isEdit ? '/open-account/update/' + this.id : '/open-account/create'
          let sign = 1
          let form = {...this.form}

          form.zc = null
          if (this.id && !this.isDelete) {
            let oldForm = JSON.parse(this.oldForm)

            sign = 0
            form = {
              id: this.id,
              uid: this.form.uid,
              applyNo: this.form.applyNo,
              sh: this.isRestart ? '1' : '0'
            }

            // 企业商户基础参数
            let createBaseInfo = this.form.createBaseInfo
            let keys = Object.keys(createBaseInfo)
            for (let i in keys) {
              let key = keys[i]
              if (createBaseInfo[key] != oldForm.createBaseInfo[key]) {
                form.createBaseInfo = this.form.createBaseInfo
                form.createBaseInfo.editFlag = '1'
                sign = 1
                break
              }
            }

            // 股东、受益人信息
            let shareholdersInfos = this.form.shareholdersInfos
            if (shareholdersInfos.length != oldForm.shareholdersInfos.length) {
              form.shareholdersInfos = this.form.shareholdersInfos
              sign = 1
            } else {
              // 外层循环加标签 outerLoop
              outerLoop:
              for (let key in shareholdersInfos) {
                let newObj = shareholdersInfos[key]
                let oldObj = oldForm.shareholdersInfos[key]
                let keys = Object.keys(newObj)
                for (let i in keys) {
                  let key = keys[i]
                  if (oldObj[key] != newObj[key]) {
                    form.shareholdersInfos = this.form.shareholdersInfos
                    sign = 1
                    break outerLoop
                  }
                }
              }
            }

            // 客户经营场景
            let cdpMerchantContextInfos = this.form.cdpMerchantContextInfos
            if (cdpMerchantContextInfos.length != oldForm.cdpMerchantContextInfos.length) {
              form.cdpMerchantContextInfos = this.form.cdpMerchantContextInfos
              sign = 1
            } else {
              // 外层循环加标签 outerLoop
              outerLoop:
              for (let key in cdpMerchantContextInfos) {
                let newObj = cdpMerchantContextInfos[key]
                let oldObj = oldForm.cdpMerchantContextInfos[key]
                let keys = Object.keys(newObj)
                for (let i in keys) {
                  let key = keys[i]
                  if (oldObj[key] != newObj[key]) {
                    form.cdpMerchantContextInfos = this.form.cdpMerchantContextInfos
                    sign = 1
                    break outerLoop
                  }
                }
              }
            }

            // 客户银行信息
            let cdpMerchantBankInfo = this.form.cdpMerchantBankInfo
            keys = Object.keys(cdpMerchantBankInfo)
            for (let i in keys) {
              let key = keys[i]
              if (cdpMerchantBankInfo[key] != oldForm.cdpMerchantBankInfo[key]) {
                form.cdpMerchantBankInfo = this.form.cdpMerchantBankInfo
                form.cdpMerchantBankInfo.editFlag = '1'
                sign = 1
                break
              }
            }

            // 客户联系人信息
            let cdpMerchantLinkInfo = this.form.cdpMerchantLinkInfo
            keys = Object.keys(cdpMerchantLinkInfo)
            for (let i in keys) {
              let key = keys[i]
              if (cdpMerchantLinkInfo[key] != oldForm.cdpMerchantLinkInfo[key]) {
                form.cdpMerchantLinkInfo = this.form.cdpMerchantLinkInfo
                sign = 1
                break
              }
            }

            // 客户经营信息
            let cdpMerchantBusinessInfo = this.form.cdpMerchantBusinessInfo
            keys = Object.keys(cdpMerchantBusinessInfo)
            for (let i in keys) {
              let key = keys[i]
              if (cdpMerchantBusinessInfo[key] != oldForm.cdpMerchantBusinessInfo[key]) {
                form.cdpMerchantBusinessInfo = this.form.cdpMerchantBusinessInfo
                sign = 1
                break
              }
            }

            // 产品
            console.log('sh:', form.sh)
            if(form.sh == '1') {
              form.apiAgreementSignApplyInfo = this.form.apiAgreementSignApplyInfo
              sign = 1
            }

            // 客户文件列表
            if (this.editFile.length > 0) {
              let baseTypes = ['0102211', '0101104', '0102101', '0102102', '0102201', '0102202']
              let baseArr = []
              let bankArr = []
              this.editFile.forEach(item => {
                if (baseTypes.indexOf(item.fileType) > -1) {
                  baseArr.push(item)
                } else {
                  bankArr.push(item)
                }
              })

              if (baseArr.length != 0) {
                let createBaseInfo = {}
                if (form.createBaseInfo) {
                  createBaseInfo = form.createBaseInfo
                }
                createBaseInfo.fileList = baseArr
                form.createBaseInfo = createBaseInfo
              }

              if (bankArr.length != 0) {
                let cdpMerchantBankInfo = {}
                if (form.cdpMerchantBankInfo) {
                  cdpMerchantBankInfo = form.cdpMerchantBankInfo
                }
                cdpMerchantBankInfo.fileList = bankArr
                form.cdpMerchantBankInfo = cdpMerchantBankInfo
              }

              if (fjObj.length != 0) {
                let cdpMerchantContextInfos = {}
                if (form.cdpMerchantContextInfos) {
                  cdpMerchantContextInfos = form.cdpMerchantContextInfos
                }
                cdpMerchantContextInfos.fileList = fjObj
                form.cdpMerchantContextInfos = cdpMerchantContextInfos
              }

              form.merchantFileInfos = this.editFile
              sign = 1
            }
            // let merchantFileInfos = this.form.merchantFileInfos
            // if (merchantFileInfos.length != oldForm.merchantFileInfos.length) {
            //   form.merchantFileInfos = this.form.merchantFileInfos
            //   sign = 1
            // } else {
            //   // 外层循环加标签 outerLoop
            //   for (let key in merchantFileInfos) {
            //     let newObj = merchantFileInfos[key]
            //     let oldObj = oldForm.merchantFileInfos[key]
            //     if (oldObj.fileUuid != newObj.fileUuid || oldObj.fileType != newObj.fileType) {
            //       form.merchantFileInfos = this.form.merchantFileInfos
            //       sign = 1
            //       break
            //     }
            //   }
            // }
          }

          console.log('sign:' + sign)

          if (sign === 1) {
            const {data} = await axios.post(url, form)
            this.btnLoading = false
            if (data && data.code === 200) {
              this.$message.success('操作成功');
              this.$router.back()
            } else {
              this.$message.error(data.msg)
            }
          } else {
            this.btnLoading = false
            this.$message.success('操作成功');
            this.$router.back()
          }
        } catch (e) {
          this.btnLoading = false
          this.$message.error('保存异常');
          console.error(e)
        }
      })
    },
    async onSave() {
      try {
        this.zcBtnLoading = true
        const {data} = await axios.post('/open-account/create', { ...this.form, zc: '1' })
        this.zcBtnLoading = false
        if (data && data.code === 200) {
          this.$message.success('操作成功');
          this.$router.back()
        } else {
          this.$message.error(data.msg)
        }
      } catch (e) {
        this.zcBtnLoading = false
        this.$message.error('保存异常');
        console.error(e)
      }
    },
    uploadSuccess(response, file, index) {
      console.log("返回结果")
      console.log(response)
      let files = this.form.merchantFileInfos
      let fileInfo = files[index]
      if (response && response.code === 0) {
        // 假设返回的数据中包含文件路径
        fileInfo.filePath = response.url
        fileInfo.fileUuid = response.uuid
        if (response.fileType === '9999999') {
          fileInfo.fileList = [{name: response.picname, url: response.url}]
        }
        this.editFile.push(fileInfo)
        this.$message.success('上传成功');
      } else {
        fileInfo.filePath = '';
        fileInfo.fileUuid = '';
        fileInfo.fileList = [];
        this.$message.error(response.msg || '上传失败');
      }
      this.$set(files, index, fileInfo)
    },
    handleProgress(file, fileList, index) {
      console.log("======过程")
      let files = this.form.merchantFileInfos
      let fileInfo = files[index]
      if (fileInfo.fileList.length > 0) {
        this.$message.error('上传失败，只能上传一个文件请删除后再传');
      }
    },
    handleRemove(file, fileList, index) {
      console.log("删除文件===")
      let files = this.form.merchantFileInfos
      let fileInfo = files[index]
      fileInfo.filePath = '';
      fileInfo.fileUuid = '';
      fileInfo.fileList = [];
      this.$set(files, index, fileInfo)
    },
    uploadError(error, file, index) {
      console.log("上传失败", error, index);
      // 重置文件路径，允许重新上传
      this.form.merchantFileInfos[index].filePath = '';
      this.form.merchantFileInfos[index].fileList = [];
      this.$message.error('上传失败，请重试');
    },
    handleClickUpload(index) {
      // if (this.editFile.length  < 3) {
        let fileInfo = this.form.merchantFileInfos[index]
        // 如果已有图片，则手动触发上传组件的点击事件
        if (fileInfo.filePath) {
          fileInfo.filePath = '';
          fileInfo.fileUuid = '';
          fileInfo.fileList = [];
          this.$set(this.form.merchantFileInfos, index, fileInfo)
          // 使用$refs访问上传组件实例，并触发其点击事件
          // const uploadRef = this.$refs[`upload-${index}`];
          // if (uploadRef && uploadRef[0]) {
          //   // 手动触发文件选择
          //   uploadRef[0].$el.querySelector('input').click();
          // }
        }
      // } else {
      //   this.$message.error('单次修改附件只能修改3个');
      // }
    },
    handleFileChange(index) {
      let files = this.form.merchantFileInfos
      let fileInfo = files[index]
      fileInfo.filePath = null
      fileInfo.fileUuid = null
      fileInfo.fileList = []
      this.$set(files, index, fileInfo)
    },
    handleTermTypeChange(val){
      if (val === '1') {
        this.form.createBaseInfo.operationEndTerm = "9999-12-31"
      } else {
        this.form.createBaseInfo.operationEndTerm = null
      }
    },
    handleLegalTypeChange(val){
      if (val === '1') {
        this.form.createBaseInfo.legalEndDate = "9999-12-31"
      } else {
        this.form.createBaseInfo.legalEndDate = null
      }
    },
    handleExpiryTypeChange(val){
      if (val === '1') {
        this.form.cdpMerchantLinkInfo.certificatesExpiryDate = "9999-12-31"
      } else {
        this.form.cdpMerchantLinkInfo.certificatesExpiryDate = null
      }
    },
    handleCertificatesTypeChange(index){
      let shares = this.form.shareholdersInfos
      let share = shares[index]
      if (share.certificatesExpiryDateType === '1') {
        share.certificatesExpiryDate = '9999-12-31'
      } else {
        share.certificatesExpiryDate = null
      }
      this.$set(shares, index, share)
    },
    handleBanckInfo(val) {
      this.rules['cdpMerchantBankInfo.bankProvince'] = []
      this.rules['cdpMerchantBankInfo.bankCity'] = []
      this.rules['cdpMerchantBankInfo.bankAddress'] = []
      if (val === '2') {
        this.rules['cdpMerchantBankInfo.bankProvince'] = [{required: true, message: '必选', trigger: 'change'}]
        this.rules['cdpMerchantBankInfo.bankCity'] = [{required: true, message: '必选', trigger: 'change'}]
        this.rules['cdpMerchantBankInfo.bankAddress'] = [{required: true, message: '必选', trigger: 'change'}]
      }
    },
    handleSyrChange() {
      if ((this.form.createBaseInfo.legalIsBeneficiary === '0' || this.form.createBaseInfo.legalIsShareholder === '0') && this.form.shareholdersInfos.length == 0) {
        this.form.shareholdersInfos = [{
          type: '',
          name: '',
          certificatesType: '',
          beneficiaryMobile: '',
          certificatesNumber: '',
          certificatesStartDate: '',
          certificatesExpiryDate: '',
          certificatesExpiryDateType: '0',
          address: ''
        }]
      }
    },
    handleZc(row){
      this.form = JSON.parse(row.zcData)
      if (this.form.createBaseInfo.operationEndTerm == '9999-12-30') {
        this.form.createBaseInfo.operationEndTermType = '1'
      } else {
        this.form.createBaseInfo.operationEndTermType = '0'
      }
      if (this.form.createBaseInfo.legalEndDate == '9999-12-30') {
        this.form.createBaseInfo.legalEndDateType = '1'
      } else {
        this.form.createBaseInfo.legalEndDateType = '0'
      }
      if (this.form.cdpMerchantLinkInfo.certificatesExpiryDate == '9999-12-30') {
        this.form.cdpMerchantLinkInfo.certificatesExpiryDateType = '1'
      } else {
        this.form.cdpMerchantLinkInfo.certificatesExpiryDateType = '0'
      }
      if (this.form.shareholdersInfos) {
        this.form.shareholdersInfos.forEach((item, index) => {
          if (item.certificatesExpiryDate == '9999-12-30') {
            item.certificatesExpiryDateType = '1'
          } else {
            item.certificatesExpiryDateType = '0'
          }
          this.$set(this.form.shareholdersInfos, index, item)
        })
      }
      if (this.form.merchantFileInfos) {
        this.form.merchantFileInfos.forEach((item, index) => {
          if (item.fileType == '9999999') {
            let arr = item.filePath.split('/')
            item.fileList = [{name: arr[arr.length - 1], url: item.filePath}]
            this.$set(this.form.merchantFileInfos, index, item)
          }
        })
      }

      console.log('规则===')
      console.log(this.form.apiAgreementSignApplyInfo.feeRuleList)
      this.form.apiAgreementSignApplyInfo.feeRuleList.forEach(item => {
        if (item.productModelId == 'M2503000001') {
          console.log("==============更改默认值")
          console.log(item.rateRuleStrategyList)
          if (item.rateRuleStrategyList && item.rateRuleStrategyList.length > 0) {
            item.rateRuleStrategyList[0].minFee = '0'
            item.rateRuleStrategyList[0].maxFee = '0'
          } else {
            item.rateRuleStrategyList = [{ feeRate:'0.0025', minFee:'0', maxFee:'0' }]
          }
        }
      })
      console.log("使用暂存信息")
      console.log(this.form)
      this.buyDialogVisible = false
    },
    handleDelFile(idx, fileUuid) {
      let arr = []
      this.editFile.forEach(item => {
        if (item.fileUuid != fileUuid) {
          arr.push(item)
        }
      })
      this.editFile = arr
      this.form.merchantFileInfos.splice(idx, 1)
    }
  }
}
</script>

<style scoped>
.page-wrap {
  padding: 12px
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px
}

.dynamic-item {
  background: #fafafa;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 10px
}

.dyn-actions {
  display: flex;
  align-items: center
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-date-editor.el-input {
  width: 100% !important;
}
.avatar-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.avatar-wrapper:hover .mask {
  opacity: 1;
  cursor: pointer;
}
</style>
